// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const savedLang =
  typeof window !== 'undefined'
    ? window.localStorage.getItem('lang') || 'ru'
    : 'ru';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: savedLang,
    fallbackLng: 'ru',
    supportedLngs: ['ru', 'en', 'es', 'zh'],
    backend: {
      // ваши файлы из предыдущего шага:
      // /locales/{lng}/translation.json
      loadPath: '/locales/{{lng}}/translation.json',
    },
    interpolation: { escapeValue: false },
    load: 'languageOnly',
    react: { useSuspense: true },
    detection: { caches: [] }, // не используем плагин-детектор, сами пишем в localStorage
    initImmediate: false,
  });

// выставляем lang у <html>
if (typeof document !== 'undefined') {
  document.documentElement.lang = savedLang;
}

export default i18n;
